export default __webpack_public_path__ + "static/media/project-chalfant.6deba068.png";